/*=========================================================================================
  File Name: getters.js
  namespace: users
  Description: Vuex Store - User getters
==========================================================================================*/

const getters = {
  getCurrentUser: state => {
    return { ...state.currentUser }
  },
  getUserToken: state => {
    return state.currentUser.token
  },
  getUserProfile: state => {
    return state.currentUser.profile.data
  },
  hasAssignedRole: state => {
    return state.currentUser.roles.data.length > 0
  },
  currentUserRoles: state => {
    return state.currentUser.roles.data
      .map(r => (r.name || '').trim().toLowerCase())
      .filter(Boolean)
  },
}

export default getters
